(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cr-addons"] && !Shopify.designMode) return;
  try {
    class CrAddons extends HTMLElement {
    connectedCallback() {
      this.status = this.querySelector('[data-addon-status]');
      this.#persistAddons();
      for (const button of this.querySelectorAll('[data-addon-add]')) {
        button.addEventListener('click', this.#add.bind(this, button));
      }
    }

    async #persistAddons() {
      const handles = (this.dataset.addonHandles || '')
        .split('|')
        .filter(Boolean)
        .join('|');
      if (!handles) return;

      try {
        await fetch(Theme.routes.cart_update_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { cr_addon_handles: handles } }),
        });
      } catch (error) {
        console.warn('Could not save add-on recommendations.', error);
      }
    }

    async #add(button) {
      const id = button.dataset.variantId;
      if (!id || button.disabled) return;

      const label = button.querySelector('[data-addon-label]');
      const original = label.textContent;
      button.disabled = true;
      label.textContent = 'Adding…';

      try {
        const productForm = this.closest('product-form-component');
        if (!productForm?.addItems) throw new Error('Product form is unavailable');
        await productForm.addItems([{ variantId: String(id), quantity: 1 }]);

        label.textContent = 'Added';
        this.#announce('Added to cart');

        setTimeout(() => {
          label.textContent = original;
          button.disabled = false;
        }, 1800);
      } catch (error) {
        label.textContent = 'Try again';
        this.#announce('Could not add that item. Try again.');
        button.disabled = false;
        setTimeout(() => {
          label.textContent = original;
        }, 2200);
      }
    }

    #announce(message) {
      if (!this.status) return;
      this.status.textContent = '';
      requestAnimationFrame(() => {
        this.status.textContent = message;
      });
    }
  }

  if (!customElements.get('cr-addons')) {
    customElements.define('cr-addons', CrAddons);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cr-bundle"] && !Shopify.designMode) return;
  try {
    class CrBundle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-bundle-add]');
      this.label = this.querySelector('[data-bundle-label]');
      this.status = this.querySelector('[data-bundle-status]');
      this.button?.addEventListener('click', this.#addBoth.bind(this));
    }

    async #addBoth() {
      const ids = (this.button.dataset.variants || '')
        .split(',')
        .map((v) => Number(v.trim()))
        .filter(Boolean);
      if (!ids.length) return;

      const original = this.label.textContent;
      this.button.disabled = true;
      this.label.textContent = 'Adding…';

      try {
        const productForm = this.closest('product-form-component');
        if (!productForm?.addItems) throw new Error('Product form is unavailable');
        await productForm.addItems(ids.map((id) => ({ variantId: String(id), quantity: 1 })));

        this.label.textContent = 'Added to cart';
        this.#announce('Both pairs added to cart');

        setTimeout(() => {
          this.label.textContent = original;
          this.button.disabled = false;
        }, 2000);
      } catch (error) {
        this.label.textContent = 'Try again';
        this.#announce('Could not add the bundle. Try again.');
        this.button.disabled = false;
        setTimeout(() => {
          this.label.textContent = original;
        }, 2400);
      }
    }

    #announce(message) {
      if (!this.status) return;
      this.status.textContent = '';
      requestAnimationFrame(() => {
        this.status.textContent = message;
      });
    }
  }

  if (!customElements.get('cr-bundle')) {
    customElements.define('cr-bundle', CrBundle);
  }
  } catch(e) { console.error(e); }
})();

})();
